import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {RankPageEnum, RankStatus, TaskStatusEnum} from './constant'

// [家族任务页面接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=138974812
export const family_tasks = createAsyncThunk(
  '/live/hg_group/get_family_tasks',
  async (arg: {family_id: number; group_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<IFamilyTasts>>(
      '/live/hg_group/get_family_tasks',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [管理中心页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=138974415
export const get_manager_info = createAsyncThunk(
  '/live/hg_family/get_manager_info',
  async (arg: {family_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<IFamilyManager>>(
      '/live/hg_family/get_manager_info',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [族长提金币] http://wiki.xunlei.cn/pages/viewpage.action?pageId=138974431
export const withdraw_coin = createAsyncThunk(
  '/live/hg_family/extract_coin',
  async (arg: {family_id: number; extract_coin: number}, store: any) => {
    const resp = await http.post(
      '/live/hg_family/extract_coin',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// [获取比例信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=138974629
export const get_manager_ratio = createAsyncThunk(
  '/live/hg_family/get_manager_ratio',
  async (arg: {family_id: number}, store: any) => {
    const resp = await http.post<HiyaRes<{ratio_list: ManagerRatioUpdate[]}>>(
      '/live/hg_family/get_manager_ratio',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [家族开业活动页面接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=138988817
export const get_open_activity_page = createAsyncThunk(
  'Family/live/hg_family/get_open_activity_page',
  async (arg: {page: RankPageEnum}, store: any) => {
    const resp = await http.post<HiyaRes<IOpenActivityPageData>>(
      '/live/hg_family/get_open_activity_page',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [女神榜接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=138988840
export const get_godness_rank = createAsyncThunk(
  'Family/live/hg_family/get_godness_rank',
  async (arg: {day: number; offset: number; limit: number}, store: any) => {
    const resp = await http.post<HiyaRes<IRankData<IGodnessRankMember>>>(
      '/live/hg_family/get_godness_rank',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

// [荣耀榜接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=138988849
export const get_honor_rank = createAsyncThunk(
  'Family/live/hg_family/get_honor_rank',
  async (arg: {offset: number; limit: number}, store: any) => {
    const resp = await http.post<HiyaRes<IRankData<IHonorRankMember>>>(
      '/live/hg_family/get_honor_rank',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

interface IPersonalInfoButton {
  text: string // 文本内容
  toast: string // 提示信息
  link: string // 跳转链接
}
interface IPersonalInfo {
  avatar: string // 头像url
  id: number //	mid/family_id
}
interface IOpenActivityPagePersonalInfoBar {
  show: boolean // 是否展示
  info: IPersonalInfo
  button: IPersonalInfoButton // 按钮
  text: string // 个人信息栏的文案
}

interface IOpenActivityPageInterceptor {
  status: RankStatus
  text: string // 拦截弹窗文案
  button_str: string // 按钮文案
  toast: string // 按钮toast
}

interface IDateTable {
  date_list: string[] // 女神页的1st、2nd、3rd天
  day: number // 当前是第几天
}
interface IOpenActivityBasePage {
  count_down: number // 倒计时结束时间戳
  banner_link: string // 点banner跳转家族聊天页
  banner_toast: string // 无家族则toast"需要加入家族才能参与"并跳转家族广场页
  date_tab: IDateTable // 女神页的1st、2nd、3rd天的信息。女神页有，荣誉页无
}

interface IOpenActivityPageData {
  err_msg: string // 错误信息
  interceptor: IOpenActivityPageInterceptor // 拦截器
  personal_info_bar: IOpenActivityPagePersonalInfoBar // 个人信息栏
  base_page: IOpenActivityBasePage // 页面的基础内容
}

interface IRankData<T> {
  err_msg: string // 错误信息
  rank_member_list: T[]
  offset: number // 下个offset
  has_more: boolean // 是否还有更多
}
interface IGodnessRankMember {
  avatar: string // 用户头像url
  mid: number // 用户id
  name: string // 用户name
  family_id: number // 家族ID
  family_name: string // 家族名称
  score: number // 女神值
  link: string // 跳转链接
  rank: number // 名次
}
interface IHonorRewardInfo {
  icon: string // 图标
  num: number // 数量
  name: string // 名称
  id: number // ID
  coin: number
  coin_display: number
}
interface IHonorRankMember {
  avatar: string // 头像url
  family_id: number // 家族ID
  family_name: string // 家族名称
  score: number // 分值
  link: string // 跳转家族详情
  rank: number // 名次
  reward_info: IHonorRewardInfo[] // 奖励信息数组
}

interface IFamilyTasts {
  rule_page_link: string // 规则页链接
  navigation_text: string // 顶部导航栏文本
  novice_tasks: INoviceTasks // 新人任务列表
  daily_tasks: IDailyTasks // 日常任务列表
}

interface INoviceTasks {
  show: boolean // 是否展示新人任务模块
  title: string // 新人任务模块标题文本
  end_time_stamp: number // 新人任务模块倒计时终点的时间戳
  task_list: ITask[] // 新人任务列表
}
interface IDailyTasks {
  task_list: ITask[] // 任务列表
}

export interface ITask {
  kind: number // 任务具体种类

  status: TaskStatusEnum
  progress: ITaskProgress
  icon: string
  title: string // 任务标题
  reward: ITaskReward // 任务奖励
  button: ITaskButton // 任务按钮
}

interface ITaskProgress {
  count: number // 当前进度
  upper_limit: number // 进度上限为负数时展示为“∞”
}
interface ITaskReward {
  // type: number // int	奖励类型	RewardPoint = 1 RewardCoin = 2
  icon: string // 奖励图标
  num: number // 奖励数量
  num_display: number // 奖励数量
  // interval: string // 奖励间隔（天/次）
  decsribe: string // 奖励描述
}
interface ITaskButton {
  text: string // 按钮文本
  link: string // 按钮链接
  toast: string
}

interface IFamilyManager {
  err_msg: string // 错误码
  curr_ratio: number // 	当前比例
  yesterday_ratio: number // 昨日比例
  add_ratio: number // 	今日增加比例
  day_consume: number // 	今日流水
  day_consume_display: number // 	今日流水
  is_max: boolean // 是否达到最大
  consume_coin: number // 消费金币
  consume_coin_display: number // 消费金币
  yesterday_diff: number // 对比昨天差值
  consume_desc: string // 分成描述
  manager_earning_coin: number // 族长收益
  extract_coin_min: number // 提现金币最小值
  extract_coin_max: number // 提现金币最大值
  extract_coin: number // 今日可提取金币数
  manager_earning_coin_display: number // 族长收益
  extract_coin_min_display: number // 提现金币最小值
  extract_coin_max_display: number // 提现金币最大值
  extract_coin_display: number // 今日可提取金币数
  visit_cnt: number // 访问人数
  new_member_cnt: number // 新人人数
  say_cnt: number // 发言人数
  send_gift_cnt: number // 送礼人数
  activity_url: string // 活动图片
  jump_url: string // 跳转链接
  is_anchor: boolean // 是否达人
  today_income: number // 今日收益
  today_income_display: number
  room_owner_sharing_ratio: number // 房主当前分成比例
  family_owner_sharing_ratio: number // 家族长当前分成比例
  room_owner_sharing_max_ratio: number // 房主最高分成比例
  family_owner_sharing_max_ratio: number // 家族长最高分成比例
  room_owner_sharing_ratio_list: any // 房主分成比例列表
  family_owner_sharing_ratio_list: any // 家族长分成比例列表
  yesterday_income: number // 昨日收益
  yesterday_income_display: number
  this_week_income: number // 本周收益
  this_week_income_display: number
  this_week_total: number // 本周流水
  this_week_total_display: number
  prev_month_income: number // 上月收益
  prev_month_income_display: number
  prev_week_income: number // 上周收益
  prev_week_income_display: number
  is_max_level: boolean // 是否达到最高等级
  cur_family_level: number // 当前家族等级
  cur_family_level_ratio: number // 当前家族等级分成比例 X%
  next_family_level: number // 下一家族等级
  next_family_level_ratio: number // 下一家族等级的分成比例
  next_family_level_room_sharing_ratio: number // 下一家族等级的家族房分成比例
  family_level_jump_url: string // 家族等级链接
  family_income_detail_jump_url: string // 家族收益明细链接
}

interface ManagerRatioUpdate {
  min: number
  max: number
  min_display: number
  max_display: number
  ratio: number
}

interface IFamily {
  family_tasks: Partial<IFamilyTasts>
  family_manager: Partial<IFamilyManager>
  ratio_list: ManagerRatioUpdate[]
  activityPageData: Partial<IOpenActivityPageData>
  goddessRankMember: Partial<IRankData<IGodnessRankMember>>
  honorRankMember: Partial<IRankData<IHonorRankMember>>
  activityShowMy: boolean
}

const initialState: IFamily = {
  family_tasks: {},
  family_manager: {},
  ratio_list: [],
  activityPageData: {},
  goddessRankMember: {},
  honorRankMember: {},
  activityShowMy: true,
}

export const FamilySlice = createSlice({
  name: 'Family',
  initialState,
  reducers: {
    setShowMy: (state, action) => {
      console.log('setShowMy, ', action.payload)
      Object.assign(state, {
        ...action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(family_tasks.fulfilled, (state, action) => {
      Object.assign(state, {family_tasks: {...action.payload}})
    })

    builder.addCase(get_manager_info.fulfilled, (state, action) => {
      Object.assign(state, {family_manager: {...action.payload}})
    })

    builder.addCase(get_manager_ratio.fulfilled, (state, action) => {
      Object.assign(state, {ratio_list: action.payload.ratio_list})
    })

    builder.addCase(get_open_activity_page.fulfilled, (state, action) => {
      Object.assign(state, {activityPageData: action.payload})
    })

    builder.addCase(get_godness_rank.fulfilled, (state, action) => {
      Object.assign(state, {goddessRankMember: action.payload})
    })

    builder.addCase(get_honor_rank.fulfilled, (state, action) => {
      Object.assign(state, {honorRankMember: action.payload})
    })
  },
})

export default FamilySlice.reducer
export const FamilyActions = FamilySlice.actions

export const useFamilyState = () => {
  const data = useSelector((state) => {
    return state.Family
  })
  return data
}
